<div class="row">
    <div class="col-4">
      <nb-card size="large">
        <nb-card-header>

          <div class="row">
            <div class="col-12">
              <h5>
                <nb-icon icon="calendar-outline"></nb-icon> Campaña actual: {{currentSeason}}
              </h5>
            </div>
          </div>
        
          <div class="row mt-2" *ngIf="!showInput">
            <div class="col-12">
              <button nbButton status="primary" (click)="inicializa()">Nueva</button>
            </div>
          </div>
        
          <div class="row mt-2" *ngIf="showInput">
            <div class="col-12">
              <input type="text" nbInput placeholder="Nombre de la nueva campaña" [(ngModel)]="newSeasonName" style="width: 100%;">
              <div *ngIf="showErrorMessage" style="color: red; font-size: 12px;">
                Introduce el nombre de la nueva campaña.
              </div>
            </div>
          </div>
        
          <div class="row mt-2" *ngIf="showInput">
            <div class="col-12">
              <label for="fechafin" style="font-size: 14px;" class="label">Fecha de inicio</label>
            </div>
            <div class="col-5">
              <input nbInput fullWidth [nbDatepicker]="datepickerFechaInicio" [(ngModel)]="newSeasonFechaInicio" (blur)="handleDateInput($event)" >
              <nb-datepicker format="dd/MM/yyyy" #datepickerFechaInicio></nb-datepicker>
              <div *ngIf="showErrorDateMessage" style="color: red; font-size: 12px;">
                La fecha no es válida.
              </div>
            </div>
          </div>

          <div class="row mt-2" *ngIf="showInput">

            <div class="col-12 text-right">
              <i class="fas fa-check-square custom-size icon-hover" (click)="onAccept()"></i>
              <i class="fas fa-window-close custom-size icon-hover" (click)="onCancel()"></i>
            </div>
            
          </div>

        </nb-card-header>
        
        <nb-card-body>

        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-8">
      <nb-card size="large">
        <nb-card-body>
          <nb-tabset>
            <nb-tab tabTitle="Asesores" tabIcon="people-outline">
              <ng2-smart-table [settings]="advisorsappliersTableSettings" [source]="advisorsappliersTableSource"
              (editConfirm)="editarAsesoresAplicadores($event)" (createConfirm)="crearAsesoresAplicadores($event)" (deleteConfirm)="eliminarAsesoresAplicadores($event)"></ng2-smart-table>
            </nb-tab>
            <nb-tab tabTitle="Maquinaria" [tabIcon]="tractorIcon">
              <ng2-smart-table [settings]="machineryTableSettings" [source]="machineryTableSource"
              (editConfirm)="editarMaquinaria($event)" (createConfirm)="crearMaquinaria($event)" (deleteConfirm)="eliminarMaquinaria($event)"></ng2-smart-table>
            </nb-tab>
            <nb-tab *ngIf="groupAdmin" tabTitle="Usuarios Agrupados" [tabIcon]="userIcon">
              <div nbLayout>
                <div nbLayoutColumn class="button-container">
                  <button nbButton status="primary" (click)="showAddUserAlert()">Invita usuario</button>
                </div>
              </div>
              <ng2-smart-table [settings]="usersAdministratedTableSettings" [source]="usersAdministratedTableSource">
              </ng2-smart-table>
            </nb-tab>
          </nb-tabset>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-3">

    </div>
</div>

<ng-template #addconfirmation let-data let-ref="dialogRef">
  <nb-card style="width: 400px;">
    <nb-card-header>Buscar Email</nb-card-header>
    <nb-card-body>
      <p>Introduce el email del usuario:</p>
      <input 
      nbInput 
      placeholder="Email" 
      type="email" 
      [(ngModel)]="email" 
      class="form-control" 
    />
    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col-md-6">
          <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
        </div>
        <div class="col-md-6 text-right">
          <button nbButton status="success" (click)="enviarEmailVerificacion(email);ref.close()">Aceptar</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
<ng-template #messageconfirmation let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Información</nb-card-header>
    <nb-card-body>
      <p>{{message}}</p>
      
    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        
        <div class="col-md-12 text-right">
          <button nbButton status="success" (click)="deleteMessage();ref.close()">Aceptar</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>